exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".categories-area2[data-v-c0e8b0fe] {\n  padding: 0 !important;\n  display: flex;\n  justify-content: center;\n}\n.category2[data-v-c0e8b0fe] {\n  margin-bottom: 20px !important;\n}\n.category-body2 ul[data-v-c0e8b0fe] {\n  margin-bottom: -35px !important;\n}", ""]);

// exports
